import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Card,
  Typography,
  Chip,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import HeaderEntreprise from '../header/headerEntreprise';
import Footer from './Footer';
import {
  Email,
  Phone,
  AssignmentInd,
  Work,
  LocationOn,
  HomeWork,
  ArrowBack,
} from '@mui/icons-material';
import HeaderRec from '../header/headerRec';

const FactureDetail = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const facture = state?.facture;

  const authToken = localStorage.getItem('authToken');
  const entrepriseName = localStorage.getItem('entrepriseName');
  const userId = localStorage.getItem('userId');
  const userType = localStorage.getItem('userType');
  const isEntreprise = userType === 'entreprise';
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [statutPaiement, setStatutPaiement] = useState(
    () => facture?.statutPaiement ?? 'Non payée'
  );
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  
  if (!facture) {
    return (
      <div className="entreprise-page">
        <HeaderEntreprise entrepriseName={entrepriseName} authToken={authToken} userId={userId} />
        <main className="pageContainer">
          <h2>Facture introuvable</h2>
          <p>Impossible de récupérer les détails de cette facture.</p>
        </main>
        <Footer />
      </div>
    );
  }

  const mission = facture.mission || {};
  const recruteur = facture.recruteur || {};
  const dateCreation = facture.dateCreation
    ? new Date(facture.dateCreation).toLocaleDateString('fr-FR')
    : 'N/A';
  const montant = facture.montant ? `${facture.montant} €` : 'N/A';
  const statut = statutPaiement === 'Payée' ? 'Payée' : 'Non payée';

  const handleStatutChange = async (newStatut) => {
    try {
      const res = await fetch(`${API_BASE}/api/entreprise/facture/statut/${facture._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ statutPaiement: newStatut }), 
      });

      if (!res.ok) throw new Error('Échec de la mise à jour');
  
      setStatutPaiement(newStatut);
    } catch (err) {
      console.error(err);
      alert('Erreur lors de la mise à jour');
    }
  };
  
  
  return (
    <Box className="cdc2-root">
      {isEntreprise ? (
        <HeaderEntreprise entrepriseName={entrepriseName} authToken={authToken} userId={userId} />
      ) : (
        <HeaderRec recruteurName={localStorage.getItem('recruteurName')} authToken={authToken} userId={userId} />
      )}

      <Grid container className="cdc2-main-grid">
        {/* Partie gauche : infos facture */}
        <Grid item xs={12} md={6} className="cdc2-grid-half">
          <Card className="cdc2-card">
            <Box className="cdc2-header-row">
              <Typography variant="h5" className="cdc2-title">
                Détail de la facture #{facture.numeroFacture}
              </Typography>
              <Chip
                label={statut}
                className={`cdc2-chip cdc2-chip-${statut === 'Payée' ? 'green' : 'red'}`}
              />
            </Box>
            
            <Box className="cdc2-info-row">
              <span className="cdc2-label">Montant : </span>
              <span className="cdc2-ref-value">{montant}</span>
            </Box>

            <Box className="cdc2-info-row">
              <span className="cdc2-label">Date de création : </span>
              <span className="cdc2-ref-value">{dateCreation}</span>
            </Box>

            <Box className="cdc2-info-row">
              <span className="cdc2-label">Mission : </span>
              <span className="cdc2-ref-value">{mission.nomMission || 'N/A'}</span>
            </Box>

            {isEntreprise ? (
            <Box
              className="cdc2-btn-row"
              sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mt: 2 }}
            >
            <Button
              variant="contained"
              color="success"
              onClick={() => setShowConfirmDialog(true)}
              disabled={statut === 'Payée'}
            >
              Payer la facture
            </Button>

            </Box>
          ) : (
            <Box
              className="cdc2-btn-row"
              sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}
            />
          )}

          </Card>
        </Grid>

        <Grid item xs={12} md={6} className="cdc2-grid-half">
          <Card className="recruiter-card">
            <Typography className="recruiter-title">Informations recruteur</Typography>

            <Box className="recruiter-info-row">
              <AssignmentInd className="recruiter-icon" />
              <span className="recruiter-label">Nom et prénom :</span>
              <span>
                {recruteur.firstName || recruteur.lastName
                  ? `${recruteur.firstName || ''} ${recruteur.lastName || ''}`
                  : 'N/A'}
              </span>
            </Box>

            <Box className="recruiter-info-row">
              <Email className="recruiter-icon" />
              <span className="recruiter-label">Email :</span>
              <span>{recruteur.email || 'N/A'}</span>
            </Box>

            <Box className="recruiter-info-row">
              <Phone className="recruiter-icon" />
              <span className="recruiter-label">Téléphone :</span>
              <span>{recruteur.phone || 'N/A'}</span>
            </Box>
          </Card>

          <Card className="recruiter-card">
            <Typography className="recruiter-title">Informations mission</Typography>

            <Box className="recruiter-info-row">
              <Work className="recruiter-icon" />
              <span className="recruiter-label">Nom de la mission :</span>
              <span>{mission.nomMission || 'N/A'}</span>
            </Box>

            <Box className="recruiter-info-row">
              <LocationOn className="recruiter-icon" />
              <span className="recruiter-label">Lieu :</span>
              <span>{mission.lieuxTravail || 'N/A'}</span>
            </Box>

            <Box className="recruiter-info-row">
              <HomeWork className="recruiter-icon" />
              <span className="recruiter-label">Mode de travail :</span>
              <span>{mission.modeTravail || 'N/A'}</span>
            </Box>
          </Card>
        </Grid>
      </Grid>

      <Footer />

      <Dialog
          open={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
        >
          <DialogTitle>Confirmation de paiement</DialogTitle>
          <DialogContent>
          <DialogContentText>
            {statutPaiement === 'Payée'
              ? 'Cette facture est déjà payée.'
              : 'Êtes-vous sûr de vouloir marquer cette facture comme payée ?'}
          </DialogContentText>

          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowConfirmDialog(false)} color="primary" variant="outlined">
              Annuler
            </Button>
            {statutPaiement !== 'Payée' && (
              <Button
                onClick={() => {
                  handleStatutChange('Payée');
                  setShowConfirmDialog(false);
                }}
                color="success"
                variant="contained"
              >
                Confirmer
              </Button>
            )}
          </DialogActions>
        </Dialog>

    </Box>
  );
};

export default FactureDetail;
